import WithDefaultMarker from './WithDefaultMarker'

export default WithDefaultMarker
